import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import RVContext from "../../RVContext";
import { Property } from "../../api/Property";
import { RVPropView } from "../../api/entities";
import ConfirmationPopup from "@my-dld/components/Popup/ConfirmationPopup";
import { navigateWithInParent, replaceNavigate } from "@my-dld/utils/StoreUtils";
import { MetricSystem } from "@my-dld/utils/UnitUtils";
import RVPropertyTable from "./RVPropertyTable";

interface Props extends RoutedViewProps {
}

interface State {
	showConfirmationAtPosition: number;
	properties?: Property[];
	isReady?: boolean;
}

class RVProperties extends Component<Props, State> {
	static contextType = RVContext;
	context!: React.ContextType<typeof RVContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			showConfirmationAtPosition: -1,
			properties: [],
		};
	}

	componentDidMount() {
		if ( this.context.properties && this.context.properties.length > 0 ) {
			const properties = this.context.properties;
			const iReady = properties && properties.length > 0 && properties.find( p => !( p.rvData && p.rvData.isDataCompleted === true ) ) === undefined;
			this.setState( { properties: properties && properties.length > 0 ? properties : [], isReady: iReady } );
		} else {
			replaceNavigate( "/mydld/rentalvaluation/searchProperty" );
		}
	}

	render() {
		const { showConfirmationAtPosition, properties } = this.state;
		return <React.Fragment>
			<div>
				{
					properties && properties.length > 0 &&
					<React.Fragment>
						<div className="alert alert-info">{ Strings.proceed_fill_missing_field }</div>
						<RVPropertyTable
							key={ "-lnd" } type={ this.context.env.propertyType! }
							properties={ properties } unit={ MetricSystem } onSelect={ this.onSelectProperty }
							view_type={ RVPropView.RV_Properties }/>
					</React.Fragment>
				}
				{
					showConfirmationAtPosition > -1 && <ConfirmationPopup
						message={ Strings.property_delete_confirmation }
						onConfirm={ () => {
							this.onDelete( showConfirmationAtPosition );
						} }
						onCancel={ this.hideConfirmation }/>
				}
				<div className="enoc-add-buyer">
					<button
						className="btn btn_1 btn_style1 btn-sm" data-bs-target="#completedProjectsModal"
						onClick={ () => {
							navigateWithInParent( "rentalvaluation", "searchProperty" );
						} }
						data-bs-toggle="modal" type="button">
						<i className="fa fa-plus"/> { Strings.add_more }
					</button>
					<button
						className="btn btn-grey btn_style1 ms-2 me-2" data-bs-target="#completedProjectsModal" disabled={ !this.state.isReady }
						onClick={ () => {
							navigateWithInParent( "rentalvaluation", "rvDocuments" );
						} }
						data-bs-toggle="modal" type="button">{ Strings.proceed }
					</button>
				</div>
			</div>
		</React.Fragment>;
	}

	onSelectProperty = ( property: Property, action?: string ) => {
		if ( action === "delete" ) {
			let temp = this.state.properties!;
			const ix = temp.findIndex( value => ( value.PropertyId === property.PropertyId ) );
			this.setState( { showConfirmationAtPosition: ix } );
		} else if ( action === "view_detail" ) {
			navigateWithInParent( "rentalvaluation", "rvPropertyInfo", undefined, { property: property } );
		}
	};

	onDelete = ( position: number ) => {
		let temp = this.state.properties!;
		temp.splice( position, 1 );
		this.setState( { properties: temp }, () => {
			if ( this.state.properties!.length < 1 ) {
				this.props.history.goBack();
			}
		} );
	};

	hideConfirmation = () => {
		this.setState( { showConfirmationAtPosition: -1 } );
	};
}

export default RVProperties;

